import React, {useRef, useState} from "react";
import { Row } from "reactstrap";
import { Resize, ResizeHorizon } from "react-resize-layout";
import { Speaking } from "../quiz/speaking";
import { ShowQuestions } from "../quiz/ShowQuestions";
import { TextArea } from "./../../components/writting_essay/textarea";
import { exerciseType } from "../../components/constants/constants";
import B2CDescription from "./B2C_Description";
import { imageURl } from "../../libs/env";
import { browserName } from "react-device-detect";

export const B2CResizableContent = ({
    exercise,
    isReview,
    setIsonRecorder,
    setSpeakingUrl,
    currentPage,
    resetAudio,
    setresetAudio,
    onblur,
    answers,
    section_id,
    page_id,
    data,
    text_area_date,
    handleCopyPaste,
    textarea_change,
    Answerslength,
    wordsCounter,
    height,
    handleScroll,
    container
}) => {
const [width1, setWidth1] = useState(exercise.separator_setting > 0 ? `${exercise.separator_setting}%` : exercise.task_type === exerciseType.WRITING_TASK ? "30%" : "65%");
const [width2, setWidth2] = useState(exercise.separator_setting > 0 ? `${100-exercise.separator_setting}%` : exercise.task_type === exerciseType.WRITING_TASK ? "70%" : "35%");
const LeftRef = useRef(null);
const RightRef = useRef(null);
const handleResizeButtonMouseDown = (event, handleResize) => {
    event.preventDefault();
    const containerWidth = container.clientWidth;
    const initialX = event.clientX;
    const initialWidth1Px = (parseFloat(width1) / 100) * containerWidth;
    const initialWidth2Px = (parseFloat(width2) / 100) * containerWidth;
    const handleMouseMove = (event) => {
      const deltaX = event.clientX - initialX;
      const newWidth1Px = initialWidth1Px + deltaX;
      const newWidth2Px = initialWidth2Px - deltaX;
      if (newWidth1Px >= 450 && newWidth2Px >= 500) {
        const newWidth1Pct = (newWidth1Px / containerWidth) * 100;
        const newWidth2Pct = (newWidth2Px / containerWidth) * 100;
        handleResize(newWidth1Pct,newWidth2Pct)
      }
    };
    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
};

const handleResize1 = (newWidth1, newWidth2) => {
    setWidth1(`${newWidth1}%`);
    setWidth2(`${newWidth2}%`);
};
const handleResize = () => {
    const Width1 = (LeftRef.current.clientWidth / container.clientWidth) * 100;
    const Width2 = (RightRef.current.clientWidth / container.clientWidth) * 100;
    if(Width1 && Width2)
    {
        setWidth1(`${Width1+4}%`);
        setWidth2(`${Width2}%`);
    }
  };

return (
<Resize handleWidth="2px" onResizeStop={handleResize} handleColor="black">
    <ResizeHorizon className={`pe-4 ps-1`} width={width1} minWidth={"450px"}>
        <B2CDescription
            height={height}
            handleScroll={handleScroll}
            description={
            <div
                spellcheck="false"
                data-gramm="false"
                ref={LeftRef}
                dangerouslySetInnerHTML={{
                __html: `${exercise.html_content?.replace(/\[\[.*?\]\]\.\s*/g, '').replace(/\[\[.*?\]\]\s*/g, '')}`,
                }}
            />
            }
        />
    </ResizeHorizon>
    <ResizeHorizon minWidth={"500px"} width={width2} className="resize-right">
        <div ref={RightRef} className="row g-0 flex-column" style={{overflow: "hidden"}}>
        {exercise.task_type === exerciseType.WRITING_TASK ? (
            <div key={exercise.id}>
            <Row style={{overflow: "hidden", height: `${height-40}px`}} className="bg-white ps-5 pe-2">
                <div style={{pointerEvents: "none"}} className="content-arrows safari-arrows ps-0 d-flex h-100 align-items-center" >
                    <div style={{cursor: "col-resize", pointerEvents: "auto"}} onMouseDown={(e) => handleResizeButtonMouseDown(e, handleResize1)}>
                        <img width="30px" src={`${imageURl}/resize-content.png`} alt="content arrows" />
                    </div>
                </div>
                <TextArea
                style={{minHeight: `${height-40}px`}}
                className="answer-area"
                data-question-type="writing"
                data-tc="writitng-text"
                data-section-id={section_id}
                data-page-id={page_id}
                data-exercise-id={exercise.id}
                defaultValue={text_area_date}
                onCopy={handleCopyPaste}
                onPaste={handleCopyPaste}
                value={isReview ? exercise.answers : null}
                onchange={textarea_change}
                onBlur={onblur}
                />
            </Row>
            <Row
                className="bg-white px-4 ps-5 py-2"
                key={`${page_id}${section_id}${exercise.id}`}
            >
                <span  className="text-muted">
                    {" "}
                    Words: {Answerslength === 0 ? Answerslength : wordsCounter} words{" "}
                </span>
            </Row> 
            </div>
        ) : (
            <Row  key={exercise.id} onScroll={handleScroll} style={{overflowY: "scroll", overflowX: "hidden", height: `${height}px`}} className={`bg-white ps-5 pe-2`}>
            <div style={{pointerEvents: "none"}} className={browserName.toLowerCase().includes("safari") ? "ps-0 safari-arrows d-flex h-100 align-items-center" : "content-arrows ps-0 d-flex h-100 align-items-center"} >
                <div style={{cursor: "col-resize", pointerEvents: "auto"}} onMouseDown={(e) => handleResizeButtonMouseDown(e, handleResize1)}>
                    <img width="30px" src={`${imageURl}/resize-content.png`} alt="content arrows" />
                </div>
            </div>
            {exercise.task_type === "Speaking Task" ||
            exercise.task_type === exerciseType.PRONUNCIATION_TASK ? (
            <Speaking
                speakingUrl={setSpeakingUrl}
                setIsonRecorder= {setIsonRecorder}
                data_section_id={section_id}
                data_page_id={page_id}
                answers={answers}
                resetAudio={resetAudio}
                setresetAudio={setresetAudio}
                data_exercise_id={exercise.id}
                data_type={data.type}
                speaking_data={exercise.speaking_plain_text_for_ml}
                isReview={isReview}
                speakingResponseURL={exercise.listening_file_url}
                Studentname={data.school_student_name}
            />
            ) : (
                <ShowQuestions
                exercise_id={exercise.id}
                section_id={section_id}
                page_id={page_id}
                questions={exercise.questions}
                task_type={exercise.task_type}
                currentPage={currentPage}
                onAnswer={onblur}
                isReview={isReview}
                answer={answers}
                status={exercise.status}
                data={data}
                ai_grading_exercise={exercise.ai_grading_task}
                />
            )}
        </Row>
        )}
        </div>
    </ResizeHorizon>
</Resize>
);
};
